//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Error',
  props: {
    error: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      pageNotFound: '404 Not Found',
      otherError: 'An error occurred',
      errors: {
        404: {
          text: 'Такой страницы больше нет или вы ввели неправильный адрес'
        }
      }
    }
  },
  computed: {
    errorText() {
      if (this.error.statusCode && this.errors[this.error.statusCode] && this.errors[this.error.statusCode].text) {
        return this.errors[this.error.statusCode].text
      }
      if (this.error.message && this.error.message.length > 5) {
        return this.error.message;
      }
      return "Неожиданная ошибка!";
    }
  },
  head () {
    const title =
      this.error.statusCode === 404 ? this.pageNotFound : this.otherError
    return {
      title
    }
  }
}
